import React from 'react';

const summaryItemClass = 'rounded-lg border border-slate-800 bg-slate-900/70 p-3';

const PlatformUsageSummaryCards = ({ summary = {} }) => {
  const cards = [
    { label: 'API Client Aktif', value: summary.activeApiClients ?? 0 },
    { label: 'Webhook Aktif', value: summary.activeWebhooks ?? 0 },
    { label: 'Total Delivery', value: summary.totalDeliveries ?? 0 },
    { label: 'Delivery Gagal', value: summary.failedDeliveries ?? 0 },
    { label: 'Integrasi Aktif', value: summary.activeIntegrations ?? 0 },
  ];

  return (
    <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-5">
      {cards.map((card) => (
        <div key={card.label} className={summaryItemClass}>
          <p className="text-xs uppercase tracking-[0.08em] text-slate-400">{card.label}</p>
          <p className="mt-1 text-2xl font-semibold text-slate-100">{card.value}</p>
        </div>
      ))}
    </div>
  );
};

export default PlatformUsageSummaryCards;
